import { useRef } from 'react';
import { Link } from 'react-router-dom';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import Navbar from './Navbar';
import Footer from './Footer';

export default function ProjectDetail({ title, subtitle, about, image1, image2, githubLink }) {
  const container = useRef();

  useGSAP(() => {
    gsap.from('.detail-anim', {
      y: 50, opacity: 0, duration: 1,
      stagger: 0.15, ease: 'power3.out', delay: 0.2,
    });
  }, { scope: container });

  return (
    <>
      <Navbar />
      <main ref={container} style={{ paddingTop: '6rem', minHeight: '100vh' }}>
        <div className="page-wrap" style={{ paddingTop: '5rem', paddingBottom: '8rem' }}>

          {/* Back link */}
          <Link to="/" className="inline-link detail-anim" style={{ fontSize: '0.85rem', display: 'block', marginBottom: '3rem' }}>
            ← Back to Portfolio
          </Link>

          {/* Header */}
          <div className="detail-anim" style={{ marginBottom: '1rem' }}>
            <span className="label-gold">Case Study</span>
          </div>
          <h1 className="display-lg detail-anim" style={{ marginBottom: '1.5rem' }}>{title}</h1>
          <p className="detail-anim" style={{ color: 'var(--muted)', fontSize: '1.15rem', maxWidth: '60ch', lineHeight: 1.8, marginBottom: '3rem' }}>
            {subtitle}
          </p>

          {/* GitHub button */}
          {githubLink && (
            <div className="detail-anim" style={{ marginBottom: '4rem' }}>
              <a href={githubLink} target="_blank" rel="noopener noreferrer" className="btn btn-gold">
                View on GitHub →
              </a>
            </div>
          )}

          <hr className="hr detail-anim" style={{ marginBottom: '5rem' }} />

          {/* About grid */}
          <div className="detail-anim detail-cols" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '4rem', marginBottom: '5rem' }}>
            <div>
              <div className="hr-gold" />
              <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '1.75rem', marginBottom: '0' }}>About This Project</h2>
            </div>
            <p style={{ color: 'var(--muted)', fontSize: '1.05rem', lineHeight: 1.9, margin: 0 }}>
              {about}
            </p>
          </div>

          <hr className="hr detail-anim" style={{ marginBottom: '4rem' }} />

          {/* Screenshots */}
          <div className="detail-anim">
            <span className="label" style={{ display: 'block', marginBottom: '2rem' }}>Project Screenshots</span>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '1.5rem',
            }}>
              {[image1, image2].filter(Boolean).map((src, i) => (
                <div key={i} style={{ overflow: 'hidden', border: '1px solid var(--border)', borderRadius: '2px' }}>
                  <img
                    src={src}
                    alt={`${title} screenshot ${i + 1}`}
                    style={{ width: '100%', display: 'block', transition: 'transform 0.5s ease' }}
                    onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.03)'}
                    onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                  />
                </div>
              ))}
            </div>
          </div>

        </div>
      </main>
      <Footer />

      <style>{`
        .detail-cols { grid-template-columns: 1fr 2fr; }
        @media (max-width: 768px) {
          .detail-cols { grid-template-columns: 1fr !important; gap: 2rem !important; }
        }
      `}</style>
    </>
  );
}